/**
 * @generated SignedSource<<e0dee6d5df4b9ca6f2e97644c9331a80>>
 * @relayHash dd0be80be508654ba05aad466cac5497
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 13b92611b7053257ce303b6ad9e881a487263bd09a560a3f7dcba673ed920c4d

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JiraBusinessTimelineAppMemoQuery } from './JiraBusinessTimelineAppMemoQuery.graphql';

const node: PreloadableConcreteRequest<JiraBusinessTimelineAppMemoQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "13b92611b7053257ce303b6ad9e881a487263bd09a560a3f7dcba673ed920c4d",
    "metadata": {},
    "name": "JiraBusinessTimelineAppMemoQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
